export default __webpack_public_path__ + "static/media/group-9.b416becb.png";